import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-portal-content-footer',
  templateUrl: './portal-content-footer.component.html',
  styleUrls: ['./portal-content-footer.component.scss', './portal-content-footer.component.en.scss']
})
export class PortalContentFooter {
  @Input() data: any;
}
